import { Locale, format } from 'date-fns';
import { i18n } from 'i18next';

import { InterviewSchedulerView } from 'constants/enums';

export const MAX_SLOTS = 7;
export const MIN_HOUR = 9;
export const MAX_HOUR = 18;
export const DAYS_AHEAD = 21;

export const getCalendarFormats = (locale: Locale) => ({
  timeGutterFormat: (date: Date) => format(date, 'h:mm a', { locale }),
  eventTimeRangeFormat: ({ start, end }: { start: Date; end: Date }) =>
    `${format(start, 'h:mm a', { locale })} – ${format(end, 'h:mm a', { locale })}`,
  dayHeaderFormat: (date: Date) => format(date, 'EEEE d', { locale }),
  dayRangeHeaderFormat: ({ start, end }: { start: Date; end: Date }) =>
    `${format(start, 'EEEE d', { locale })} – ${format(end, 'EEEE d', { locale })}`,
  dayFormat: (date: Date) => format(date, 'EEEE d', { locale }),
  weekdayFormat: (date: Date) => format(date, 'EEEE d', { locale }),
  monthHeaderFormat: (date: Date) => format(date, 'MMMM yyyy', { locale })
});

export const getCalendarMessages = (i18nInstance: i18n) => ({
  showMore: (total: number) => i18nInstance.t('calendar.showMore', { total })
});

export const calendarSettings = {
  step: 60,
  timeslots: 1,
  defaultMobileView: InterviewSchedulerView.Day,
  defaultDesktopView: InterviewSchedulerView.Month,
  mobileViews: [InterviewSchedulerView.Day],
  desktopViews: [InterviewSchedulerView.Week, InterviewSchedulerView.Month],
  longPressThresholdMobile: 50,
  longPressThresholdDesktop: 250,
  mobileClickDelay: 300
};

export enum NavigationAction {
  Prev = 'PREV',
  Today = 'TODAY',
  Next = 'NEXT'
}
